"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ListContainer = _styledComponents["default"].div.withConfig({
  componentId: "iful7m-0"
})(["display:flex;flex-direction:column;width:100%;"]);

var ListItem = _styledComponents["default"].div.withConfig({
  componentId: "iful7m-1"
})(["display:flex;width:100%;margin-bottom:", "px;:last-child{margin-bottom:0;}"], function (props) {
  return props.spacing || (0, _themeGet.themeGet)('space.2');
});

var StyledTitle = _styledComponents["default"].div.withConfig({
  componentId: "iful7m-2"
})(["font-size:", "px;font-weight:", ";margin-bottom:", "px;"], (0, _themeGet.themeGet)('fontSizes.3'), (0, _themeGet.themeGet)('fontWeights.bold'), (0, _themeGet.themeGet)('space.3'));

var renderItems = function renderItems(items) {
  var ItemComponent = items && items.type;
  return items && items.list && items.list.length > 0 ? items.list.map(function (item, index) {
    return _react["default"].createElement(ListItem, {
      key: index
    }, _react["default"].createElement(ItemComponent, item));
  }) : null;
};

var renderChildren = function renderChildren(children) {
  return _react["default"].Children.map(children, function (child, index) {
    return _react["default"].createElement(ListItem, {
      key: index
    }, child);
  });
};

var List = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      title = _ref.title,
      items = _ref.items,
      children = _ref.children,
      spacing = _ref.spacing;
  return _react["default"].createElement(ListContainer, {
    className: className,
    spacing: spacing
  }, title && _react["default"].createElement(StyledTitle, null, title), renderItems(items), renderChildren(children));
});
List.displayName = 'List';
List.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string,
  items: _propTypes["default"].shape({
    type: _propTypes["default"].func.isRequired,
    list: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
  }),
  children: _propTypes["default"].node,
  spacing: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
List.defaultProps = {
  className: ''
};
var _default = List;
exports["default"] = _default;